<template>
  <div class="app-container">
    <el-form :model="queryParams" class="multipleSelectScroll" ref="queryForm" v-show="showSearch" label-width="80px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="联系人" prop="contactName">
            <el-input v-model="queryParams.contactName" @keyup.enter.native="getList" placeholder="请输入联系人" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="queryParams.customerName" @keyup.enter.native="getList" placeholder="请输入客户名称" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="线索状态" prop="clueStatusList">
            <el-select v-model="queryParams.clueStatusList" placeholder="请选择线索状态" clearable multiple style="width:100%">
              <el-option v-for="dict in statusOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="创建时间" prop="createTime">
            <el-date-picker v-model="queryParams.createTime" value-format="yyyy-MM-dd" type="daterange" range-separator="-" style="width:100%" start-placeholder="开始日期" end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="mb8">
        <dept-user-select ref="deptUserSelectRef" :formParam="queryParams" :autoSelectUser="autoSelectUser"></dept-user-select>
        <el-col :xs="24" :md="24" :lg="24" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-user" :disabled="multiple" @click="handleAssign">分配</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="dataList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" fixed="left" align="center" :selectable="selectable"/>
      <el-table-column label="客户名称" min-width="180" align="center" prop="customerName" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail(scope.row)">{{scope.row.customerName}}</el-link>
        </template>
      </el-table-column >
      <el-table-column label="联系人" min-width="90" align="center" prop="contactName" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toContactDetail(scope.row)">{{scope.row.contactName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="手机号" width="120" align="center" prop="contactMobile" fixed="left">
        <template slot-scope="scope">
          <el-button type="text" title="点击获取完整手机号" v-if="scope.row.contactMobile.indexOf('**')>=0"
                     @click="queryMobile(scope.row)">{{ scope.row.contactMobile }}</el-button>
          <span v-else>{{ scope.row.contactMobile }}</span>
        </template>
      </el-table-column>
      <el-table-column label="线索来源" width="100" align="center" prop="clueSourceDesc"/>
      <el-table-column label="当前状态" width="100" align="center" prop="displayStatusDesc">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toDetail(scope.row)">{{scope.row.displayStatusDesc || scope.row.clueStatusDesc}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="负责人" width="80" align="center" prop="managerName" />
      <el-table-column label="最新跟进记录" min-width="150" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="Boolean(scope.row.lastFollowInfo)" style="text-align: left;">
            <span v-if="scope.row.lastFollowInfo.followTypeDesc">{{scope.row.lastFollowInfo.followTypeDesc}} 跟进：<br></span>
            <span>{{scope.row.lastFollowInfo.content}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="最新跟进人" width="100" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.lastFollowInfo ? scope.row.lastFollowInfo.followerName : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column label="最新跟进时间" width="170" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.lastFollowInfo ? scope.row.lastFollowInfo.createTime : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建人" width="80" align="center" prop="createByUserName"/>
      <el-table-column label="创建时间" width="170" align="center" prop="createTime" />
      <el-table-column label="操作" width="220" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text" v-if="scope.row.canOperateFlag && scope.row.clueStatus === 'follow_up'" @click="handleFollow(scope.row)">跟进</el-button>
          <el-button type="text" v-if="scope.row.canOperateFlag && scope.row.clueStatus === 'follow_up'" @click="handlePlan(scope.row)">计划</el-button>
          <el-button type="text" v-if="scope.row.canOperateFlag && scope.row.clueStatus === 'follow_up'" @click="handleClueToBusiness(scope.row)">转商机</el-button>
          <el-button type="text" v-if="scope.row.canOperateFlag && scope.row.clueStatus === 'follow_up'" @click="handleCloseClue(scope.row)">关闭</el-button>
          <el-button type="text" v-if="scope.row.canOperateFlag && scope.row.clueStatus === 'closed'" @click="handleOpenClue(scope.row)">恢复</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList"/>

    <AssignDialog ref="assignDialogRef" @success="getList"></AssignDialog>
    <AddClueDialog ref="addClueDialogRef" @success="getList"></AddClueDialog>
    <PlanAddDialog ref="planAddDialogRef" @success="getList"></PlanAddDialog>
    <FollowAddDialog ref="followAddDialogRef" @success="getList"></FollowAddDialog>
    <ClueToBusinessDialog ref="clueToBusinessDialogRef" @success="getList"></ClueToBusinessDialog>
    <CloseClueDialog ref="closeClueDialogRef" @success="getList"></CloseClueDialog>
    <OpenClueDialog ref="openClueDialogRef" @success="getList"></OpenClueDialog>
  </div>
</template>

<script>
import {queryClueList} from "@/api/crm/clue";
import {desensitizeMobile} from '@/utils/index'
import UserSelect from "@/views/crm/components/userSelect";
import AssignDialog from "@/views/crm/components/assignDialog";
import AddClueDialog from "@/views/crm/clue/addClueDialog";
import PlanAddDialog from "@/views/crm/plan/planAddDialog";
import FollowAddDialog from "@/views/crm/follow/followAddDialog";
import ClueToBusinessDialog from "@/views/crm/clue/clueToBusinessDialog";
import CloseClueDialog from "@/views/crm/clue/closeClueDialog";
import OpenClueDialog from "@/views/crm/clue/openClueDialog";
import {mapState} from 'vuex'
import deptUserSelect from "@/views/crm/components/deptUserSelect";
import {queryMobile} from "@/api/crm/contact";

export default {
  name: "ClueManage",
  data() {
    return {
      desensitizeMobile,
      autoSelectUser: true,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      dataList: [],
      // 线索状态字典
      statusOptions: [],
      // 线索来源字典
      sourceOptions: [],
      contactList: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        contactName: null,
        customerName: null,
        clueStatusList: [],
        createTime: [],
        deptIdList: [],
        managerIdList: []
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    UserSelect,
    AssignDialog,
    AddClueDialog,
    FollowAddDialog,
    PlanAddDialog,
    CloseClueDialog,
    OpenClueDialog,
    ClueToBusinessDialog,
    deptUserSelect,
  },
  created() {
    if (!this.$route.query.isAll) {
      this.queryParams.managerIdList = [this.currentUserId]
    }
    let workParams = this.$route.params // 工作台跳转进来
    if(Object.keys(workParams).length){
      this.autoSelectUser = false
      this.queryParams.createTime = workParams.createTime
      this.queryParams.deptIdList = workParams.deptIdList
      this.queryParams.managerIdList = workParams.managerIdList
    }else {
      this.autoSelectUser = true
    }
    this.getList();
    this.getDicts("clue_status").then(response => {
      this.statusOptions = response.data;
    });
  },
  methods: {
    getList() {
      this.loading = true;
      let params = JSON.parse(JSON.stringify(this.queryParams));
      if (params.createTime && params.createTime.length > 1) {
        params.startDate = params.createTime[0]
        params.endDate = params.createTime[1]
      }
      params.createTime = undefined;
      queryClueList(params).then(response => {
          this.dataList = response.rows || [];
          this.total = response.total;
          this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.createTime = []
      this.queryParams.deptIdList = []
      this.$refs.deptUserSelectRef.deptSelect()
      this.handleQuery();
    },
    // 是否可选
    selectable (row, index) {
      return row.canOperateFlag && row.clueStatus === 'follow_up';
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.multiple = !selection.length;
    },
    /** 详细按钮操作 */
    toDetail(row) {
      window.open("/crm/clue/detail/" + row.id, "_blank")
    },
    toCustomerDetail(row) {
      window.open("/crm/customer/detail/" + row.customerId, "_blank")
    },
    toContactDetail(row) {
      window.open("/crm/contact/detail/" + row.contactId, "_blank")
    },
    /** 跟进按钮操作 */
    handleFollow(row) {
      this.$refs.followAddDialogRef.open("clue", row.id);
    },
    /** 转商机按钮操作 */
    handleClueToBusiness(row) {
      this.$refs.clueToBusinessDialogRef.open(row.id);
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.$refs.addClueDialogRef.open();
    },
    /** 分配按钮操作 */
    handleAssign() {
      this.$refs.assignDialogRef.batchAssign("clue", this.ids)
    },
    /** 计划按钮操作 */
    handlePlan(row) {
      this.$refs.planAddDialogRef.open("clue", row.id, row.managerId);
    },
    /** 关闭按钮操作 */
    handleCloseClue(row) {
      this.$refs.closeClueDialogRef.open(row.id, row.informantName);
    },
    /** 恢复按钮操作 */
    handleOpenClue(row) {
      this.$refs.openClueDialogRef.open(row.id, row.informantName);
    },
    queryMobile(row){
      const loading = this.$loading({lock: true, text: '查询中', spinner: 'el-icon-loading'});
      queryMobile({
        id: row.contactId
      }).then(response => {
        if (response.data) {
          row.contactMobile = response.data
        }
      }).finally(error => {
        loading.close()
      })
    }
  }
};
</script>
